<template>
  <v-container>
    <ApiTokensTable />
  </v-container>
</template>

<script>
import ApiTokensTable from "./ApiTokensTable.vue";

export default {
  components: {
    ApiTokensTable,
  },
  props: {},
  data() {
    return {
      
    };
  },
  mounted() {},
  methods: {},
  watch: {},
  computed: {},
};
</script>
